import { API_REQUEST, GET_USER_INFO, UPDATE_ACCOUNT_SETTINGS, RESET_UPDATE_ACCOUNT_SETTINGS } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

// Manage user info action
export const getUserInfo = (userId: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/get/${userId}`,
        next: GET_USER_INFO,
        method: 'GET',
        authorization: true
    }
});

export const updateUserInfo = (userId: string, apiPayload: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/patch/${userId}`,
        next: UPDATE_ACCOUNT_SETTINGS,
        method: 'PATCH',
        data: apiPayload,
        authorization: true
    }
});

export const resetUpdateState = (): AppAction => ({
    type: RESET_UPDATE_ACCOUNT_SETTINGS,
    payload: {}
})